import { computed, type Ref } from "vue";
import { useQuery } from "@tanstack/vue-query";
import Report from "@/services/analytics/report";
import type { OpportunityDashboardRequestBody } from "./useOpportunityDashboardFilters";

export interface LeadSourceOpportunitiesParams extends OpportunityDashboardRequestBody {
  leadSourceId: string;
  leadSourceName?: string;
}

export function useLeadSourceOpportunities(params: Ref<LeadSourceOpportunitiesParams | null>) {
  const queryKey = computed(() => {
    const p = params.value;
    if (!p) return ["leadSourceOpportunities", "disabled"];
    return ["leadSourceOpportunities", JSON.stringify(p)];
  });

  const enabled = computed(() => {
    return params.value !== null && !!params.value.organizationId && !!params.value.leadSourceId;
  });

  return useQuery({
    queryKey,
    queryFn: async () => {
      const p = params.value;
      if (!p) throw new Error("Parameters not ready");

      const response = await Report.getLeadSourceOpportunities(p);

      if (response.data?.status && response.data?.data) {
        return response.data.data;
      }

      return [];
    },
    enabled,
    staleTime: 30 * 1000,
    gcTime: 5 * 60 * 1000,
  });
}
